import ClearIcon from '@mui/icons-material/Clear';
import { InputLabel, MenuItem, FormControl, Select, Button } from '@mui/material';
import { ref, update, remove } from 'firebase/database';
import Cookies from 'js-cookie';
import { useState, useEffect, useRef } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { getTeachers, updateStatisticsFunc } from '../../Common/Database';
import { database } from '../../Common/Firebase';
import CreateTeacherModal from '../../Components/CreateTeacherModal';
import Loader from '../../Components/Loader';
import NoItems from '../../Components/NoItems';
import ResetButton from '../../Components/ResetButton';
import Tooltipe from '../../Components/Tooltipe';
import { throwErrorRollbar } from '../../index';
import { setTeacherNames } from '../../redux/slices/nameTeachersSlice';
import '../StudentList/style.scss';

const { SearchBar } = Search;

const TeacherList = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchRef = useRef(null);

  const selectedFilterBranch = JSON.parse(Cookies.get('selectedFilterBranch') ?? '{}');

  const selectedFilterCity = JSON.parse(Cookies.get('selectedFilterCity') ?? '{}');

  const [teacherItems, setTeacherItems] = useState([]);
  const [unicBranch, setUnicBranch] = useState([]);
  const [unicCity, setUnicCity] = useState([]);
  const [teacherActive, setTeacherActive] = useState();
  const [teacherParamsId, setTeacherParamsId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [teacher, setTeacher] = useState([]);
  const [popupRemove, setPopupRemove] = useState(false);

  const [selectedBranch, setSelectedBranch] = useState(selectedFilterBranch.selectedBranch ?? '');

  const [selectedCity, setSelectedCity] = useState(selectedFilterCity.selectedCity ?? '');

  const normalizeTeachers = list => {
    return Object.values(list ?? {})
      .filter(t => !!t) // прибрати null/undefined
      .filter(t => !!t.email) // гарантуємо keyField
      .map(t => ({
        ...t,
        _key: String(t.email),
      }));
  };

  const onTeacherBranch = e => {
    selectedFilterBranch.selectedBranch = e.target.value;
    Cookies.set('selectedFilterBranch', JSON.stringify(selectedFilterBranch));
    setSelectedBranch(e.target.value);
  };

  const onTeacherCity = e => {
    selectedFilterCity.selectedCity = e.target.value;
    Cookies.set('selectedFilterCity', JSON.stringify(selectedFilterCity));
    setSelectedCity(e.target.value);
  };

  const fetchBranch = async () => {
    const teachersList = await getTeachers();
    if (teachersList) {
      const mapList = Object.values(teachersList).filter(Boolean);
      const uniqArr = [...new Set(mapList.map(item => item?.branch))].filter(Boolean);
      uniqArr.sort();
      setUnicBranch(uniqArr);
    }
  };

  const fetchCity = async () => {
    const teachersList = await getTeachers();
    if (teachersList) {
      const mapList = Object.values(teachersList).filter(Boolean);
      const uniqArr = [...new Set(mapList.map(item => item?.city))].filter(Boolean);
      uniqArr.sort();
      setUnicCity(uniqArr);
    }
  };

  useEffect(() => {
    fetchBranch();
    fetchCity();
  }, []);

  const fetchTeachersListData = async () => {
    const teacherList = await getTeachers(selectedBranch, selectedCity);
    const rows = normalizeTeachers(teacherList);
    setTeacherItems(rows);
    dispatch(setTeacherNames(rows));
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTeachersListData();
  }, [selectedBranch, selectedCity]);

  const removeTeacher = async () => {
    const teachId = localStorage.getItem('teacherId');
    await remove(ref(database, `Teachers/${teachId}`), {
      teachId,
    });
    updateStatisticsFunc('FindingTeachersSite', 'decrement');
    localStorage.removeItem('teacherId');
    fetchTeachersListData();
    setPopupRemove(false);

    setTimeout(() => {
      searchRef.current.props.onSearch('');
    }, 0);
  };

  const notRemoveTeacher = () => {
    localStorage.removeItem('teacherId');
    setPopupRemove(false);
  };

  const columns = [
    { dataField: 'id', hidden: true },
    {
      dataField: 'FIO',
      text: t('fio teacher'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('fio') },
      sort: true,
    },
    {
      dataField: 'email',
      text: t('email'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('email') },
    },
    {
      dataField: 'city',
      text: t('city'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('city') },
      formatter: cell => {
        return cell !== '' ? cell : '-';
      },
    },
    {
      dataField: 'branch',
      text: t('branch'),
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('branch') },
      formatter: cell => {
        return cell !== '' ? cell : '-';
      },
    },
    {
      dataField: 'active',
      text: t('activation'),
      headerStyle: {
        width: '100px',
      },
      disableClickEventBubbling: true,
      attrs: { 'data-label': t('activation') },
      formatter: dataField => {
        const buttonStyles = {
          background: dataField ? '#f2e6ed' : '#9cdffc',
        };

        return (
          <button id={String(dataField)} style={buttonStyles} className="btn btn-primary more btn-active">
            {dataField ? t('turnOff') : t('turnOn')}
          </button>
        );
      },
    },
    {
      dataField: 'id',
      text: <div className="sticky-wrap">{t('options')}</div>,
      attrs: { 'data-label': t('options') },
      headerStyle: {
        width: '50px',
      },
      formatter: dataField => (
        <div className="actions-wrap">
          <div className="btn-wrap">
            <Tooltipe text="view" icon="icon-preview" btnClass="move-view" />
            <Tooltipe text="delete" icon="icon-delete" btnClass="move-delete" />
          </div>
        </div>
      ),
    },
  ];

  const defaultSorted = [
    {
      dataField: 'FIO',
      order: 'asc',
    },
  ];

  const rowEvents = {
    onClick: async (e, row) => {
      const teacherEmail = row?.email ?? '';
      const teacherId = teacherEmail.replace(/\./g, '');
      if (!teacherEmail) return;

      if (e.target.className === 'btn btn-icon move-view') {
        sessionStorage.setItem('TeacherView', JSON.stringify(row));
        navigate(`/teacherView/${teacherId}`);
      }

      if (e.target.className === 'btn btn-primary more btn-active') {
        try {
          await update(ref(database, `Teachers/${teacherId}`), {
            active: !row.active,
          });

          setTeacherActive(prev => !prev);
          fetchTeachersListData();
          setTeacherParamsId(teacherId);
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }
      }

      if (e.target.className === 'btn btn-icon move-delete') {
        try {
          localStorage.setItem('teacherId', teacherId);
          setPopupRemove(true);
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }
      }
    },
  };

  const pageSize = 10;

  const pagination = paginationFactory({
    sizePerPage: pageSize,
    hideSizePerPage: true,
    page: Number(selectedFilterCity.page) || 1,
    onPageChange: page => {
      selectedFilterCity.page = page;
      Cookies.set('selectedFilterCity', JSON.stringify(selectedFilterCity));
    },
  });

  const openModalCreateTeacher = () => {
    setOpenModal(true);
  };

  setTimeout(() => {
    searchRef.current?.props?.onSearch?.('');
  }, 0);

  // TODO: mechanism for transferring Sups to Teachers
  // const getSupsTeachets = async () => {
  //   const supsList = await getSups();
  //   if (supsList) {
  //     let mapListSups = Object.values(supsList);
  //     console.log('mapList: ', mapListSups);
  //     supsList.forEach(async (item) => {
  //       const key = item.key;
  //       console.log('key: ', key);
  //       const value = item.value.FIO;
  //       console.log('value: ', value);

  //       try {
  //         update(ref(database, `Teachers/${key}`), {
  //           FIO: value,
  //           lastName: '',
  //           firstName: '',
  //           patronymic: '',
  //           phone: '',
  //           city: '',
  //           email: key,
  //           branch: '',
  //           active: true,
  //           type: 'Teacher',
  //           subjects: {
  //             english: {
  //               activeSub: false,
  //               name: 'english',
  //               getNotebook: false,
  //             },
  //             geography: {
  //               activeSub: false,
  //               name: 'geography',
  //               getNotebook: false,
  //             },
  //             geometry: {
  //               activeSub: false,
  //               name: 'geometry',
  //               getNotebook: false,
  //             },
  //             historyUkraine: {
  //               activeSub: false,
  //               name: 'historyUkraine',
  //               getNotebook: false,
  //             },
  //             ukrainianLanguage: {
  //               activeSub: false,
  //               name: 'ukrainianLanguage',
  //               getNotebook: false,
  //             },
  //             physics: {
  //               activeSub: false,
  //               name: 'physics',
  //               getNotebook: false,
  //             },
  //             biology: {
  //               activeSub: false,
  //               name: 'biology',
  //               getNotebook: false,
  //             },
  //             mathematics: {
  //               activeSub: false,
  //               name: 'mathematics',
  //               getNotebook: false,
  //             },
  //             nature: {
  //               activeSub: false,
  //               name: 'nature',
  //               getNotebook: false,
  //             },
  //             algebra: {
  //               activeSub: false,
  //               name: 'algebra',
  //               getNotebook: false,
  //             },
  //             youngSchoolMathematics: {
  //               activeSub: false,
  //               name: 'youngSchoolMathematics',
  //               getNotebook: false,
  //             },
  //             allWorldHistory: {
  //               activeSub: false,
  //               name: 'allWorldHistory',
  //               getNotebook: false,
  //             },
  //             chemistry: {
  //               activeSub: false,
  //               name: 'chemistry',
  //               getNotebook: false,
  //             },
  //             youngSchoolRussianLanguage: {
  //               activeSub: false,
  //               name: 'youngSchoolRussianLanguage',
  //               getNotebook: false,
  //             },
  //             ukrainianLiterature: {
  //               activeSub: false,
  //               name: 'ukrainianLiterature',
  //               getNotebook: false,
  //             },
  //             foreignLiterature: {
  //               activeSub: false,
  //               name: 'foreignLiterature',
  //               getNotebook: false,
  //             },
  //             youngUkrainianLanguage: {
  //               activeSub: false,
  //               name: 'youngUkrainianLanguage',
  //               getNotebook: false,
  //             },
  //             german: {
  //               activeSub: false,
  //               name: 'german',
  //               getNotebook: false,
  //             },
  //             kvol: {
  //               activeSub: false,
  //               name: 'kvol',
  //               getNotebook: false,
  //             },
  //           },
  //         });
  //       } catch (error) {
  //         console.log(error);
  //         throwErrorRollbar(error);
  //       }
  //     })
  //   }
  // }

  return (
    <>
      <ToolkitProvider key={i18n.language} keyField="_key" data={teacherItems} columns={columns} search>
        {props => (
          <div className="materials-page students-page teachers-page container">
            <ul className="filters-list first-list">
              <li>
                <FormControl fullWidth>
                  <InputLabel id="branch-hw-label">{t('branch')}</InputLabel>
                  <Select
                    labelId="branch-label"
                    id="branch-hw-select"
                    value={selectedBranch}
                    label={t('branch')}
                    onChange={onTeacherBranch}
                    endAdornment={
                      selectedBranch && (
                        <ResetButton
                          onClick={() => {
                            setSelectedBranch('');
                            Cookies.set('selectedFilterBranch', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicBranch.map(branch => {
                      return (
                        <MenuItem key={branch} value={branch}>
                          {branch}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </li>
              <li>
                <FormControl fullWidth>
                  <InputLabel id="city-hw-label">{t('city')}</InputLabel>
                  <Select
                    labelId="city-label"
                    id="city-hw-select"
                    value={selectedCity}
                    label={t('city')}
                    onChange={onTeacherCity}
                    endAdornment={
                      selectedCity && (
                        <ResetButton
                          onClick={() => {
                            setSelectedCity('');
                            Cookies.set('selectedFilterCity', JSON.stringify({}));
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </ResetButton>
                      )
                    }
                  >
                    {unicCity.map(city => {
                      return (
                        <MenuItem key={city} value={city}>
                          {city}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </li>
              <li className="search-input">
                <SearchBar {...props.searchProps} srText="" placeholder={t('search')} ref={searchRef} />
              </li>
              <li>
                <Button className="btn clear-filter with-icon" onClick={() => openModalCreateTeacher()}>
                  <span className="icon icon-plus"></span>
                  <span className="title">{t('create Teacher')}</span>
                </Button>
              </li>
            </ul>
            <hr />
            <div className="materials-table">
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  {teacherItems ? (
                    <BootstrapTable
                      {...props.baseProps}
                      pagination={teacherItems.length > pageSize ? pagination : null}
                      rowEvents={rowEvents}
                      defaultSorted={defaultSorted}
                    />
                  ) : (
                    <NoItems titleNoItems={t('noTeachers')} />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </ToolkitProvider>

      {openModal && (
        <CreateTeacherModal
          open={openModal}
          setOpen={setOpenModal}
          title={t('create Teacher')}
          submit={t('create')}
          nameAction={'createForm'}
          updateFormObj={''}
          teacher={teacher}
          fetchTeachersListData={fetchTeachersListData}
        />
      )}

      <div className={popupRemove ? 'popup-remove active' : 'popup-remove'}>
        <div className="popup-remove-content">
          <h3>{t('do you want delete teacher?')}</h3>
          <div className="btn-wrap">
            <button className="btn btn-primary more btn-active" onClick={() => removeTeacher()}>
              {t('yes')}
            </button>
            <button className="btn more btn-view" onClick={notRemoveTeacher}>
              {t('no')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherList;
